import httpClient from '@/core/http/client.service';

const getPatientRegistationFormInfo = () => httpClient.get('/api/v1/tpn/patientRegistation?_format=json').then((res) => res);
const createPatientRegistation = (data) => httpClient.post('/api/v1/tpn/patientRegistation?_format=json', data);
const savePatientRegistation = (data) => httpClient.post('/api/v1/tpn/patientRegistrationRecord?_format=json', data);
const deletePatientRegistation = (data) => httpClient.delete('/api/v1/tpn/patientRegistrationRecord/' + data + '?_format=json');

export default {
  getPatientRegistationFormInfo,
  createPatientRegistation,
  savePatientRegistation,
  deletePatientRegistation,
};
